import * as React from "react";

import { Modal } from "src/library/components/Modal";

interface IProps {
  show: boolean;
  handleDismiss: () => void;
  onIgnoreErrors: () => void;
}

const ConfirmIgnoreModal: React.ReactFCWithChildren<IProps> = ({
  show, handleDismiss, onIgnoreErrors
}) => {
  return (
    <Modal
      small
      type="confirm"
      show={show}
      title="Ignore Errors"
      body="Are you sure you want to ignore these errors?"
      actions={[
        {
          name: "Ignore Errors",
          action: () => {
            onIgnoreErrors();
            handleDismiss();
          },
          $buttonType: "secondary"
        },
        {
          name: "Cancel",
          action: () => {
            handleDismiss();
          },
          $buttonType: "primary"
        }
      ]}
      backgroundAction={() => handleDismiss()}
    />
  );
};

export default ConfirmIgnoreModal;
